import type { WithMetadata } from "../../../../../pages";
import { HelpLink as DefaultHelpLink } from "./HelpLink";
import { HelpLink as CompareTheMarketHelpLink } from "./CompareTheMarketHelpLink";
import { useEnvironmentValues } from "../../../../../hooks/environment";

export type HelpLinkProps = {
  headline: string;
  label: string;
  text: string;
  displayAsButton?: boolean;
  onOpenDrawer?: () => void;
};

export const HelpLink = (props: WithMetadata<HelpLinkProps>) => {
  const { site } = useEnvironmentValues();

  if (site === "comparethemarket") {
    return <CompareTheMarketHelpLink {...props} />;
  }

  return <DefaultHelpLink {...props} />;
};
